class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._eventAttached = false;
    setTimeout(() => {
      this.form = this.querySelector('form');
      if (!this.form) {
        console.warn('Form not found in ProductForm');
        return;
      }
      this.idInput = this.form.elements['id'];
      this.submitButton = this.form.elements['add'];

      if (this.idInput) {
        this.idInput.removeAttribute('disabled');
      }

      this.notifyOnAdd = this.hasAttribute('notify-on-add');
      this._boundSubmit = this.submit.bind(this);

      this._eventAttached = true;
      this.form.addEventListener('submit', this._boundSubmit);
    });
  }

  disconnectedCallback() {
    if (this._eventAttached && this.form) {
      this._eventAttached = false;
      this.form.removeEventListener('submit', this._boundSubmit);
    }
  }

  async submit(e) {
    e.preventDefault();
    if (!e.target) {
      console.error('Submit event target not found');
      return;
    }

    const data = new FormData(e.target);
    const item = Object.fromEntries(data.entries());

    try {
      this.removeError();
      await this._setIsAdding();
      await window.theme.cart.store.getState().add(item);
      await this._setIsAdding(false);

      const quickShop = this.closest('quick-shop');
      if (quickShop) {
        await quickShop.hide();
      }

      if (this.notifyOnAdd) {
        await window.theme.cart.store.getState().resetVariantsBeingAdded();
        if (!this.closest('.cart-draw')) {
          if (typeof theme.mfpOpen === 'function') {
            theme.mfpOpen('cart');
          } else {
            console.warn('theme.mfpOpen function is missing.');
          }
        }
      } else {
        await window.theme.cart.store.getState().resetLatestAddedProduct();
        await window.theme.cart.store.getState().resetVariantsBeingAdded(item.id);
      }
    } catch (e) {
      this._renderError(e.message);
      console.error(e);
      await this._setIsAdding(false, true);
    }
  }

  _setIsAdding(isAdding = true, error = false) {
    return new Promise((resolve) => {
      if (!this.submitButton) {
        console.warn('Submit button not found.');
        resolve('No submit button');
        return;
      }

      if (error) {
        this.submitButton.classList.remove('is-adding');
        resolve('error');
        return;
      }

      if (isAdding) {
        this.submitButton.classList.remove('is-added');
        this.submitButton.classList.add('is-adding');
        resolve('Adding');
      } else {
        this.submitButton.classList.remove('is-adding');
        this.submitButton.classList.add('is-added');

        this.submitButton.addEventListener('animationend', () => {
          this.submitButton.classList.remove('is-added');
          resolve('Added');
        }, { once: true });
      }
    });
  }

  _renderError(message) {
    this.removeError();

    if (this.submitButton) {
      const error = document.createElement('div');
      error.classList.add('errors', 'qty-error', 'u-small');
      error.textContent = message;
      this.submitButton.before(error);
    } else {
      console.error('Submit button not found. Cannot display error:', message);
    }
  }

  removeError() {
    const error = this.querySelector('.errors');
    if (error) {
      error.remove();
    }
  }
}

customElements.define('product-form', ProductForm);
